import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { Platform, StyleSheet } from 'react-native';

import { IconLink, theme, useResponsive } from '@sg/garnish';

export const RightIcon = ({ onPress }: Readonly<{ onPress: () => void }>) => {
  const { formatMessage } = useIntl();
  const { match } = useResponsive();

  return (
    <IconLink
      testID="location.search-bar.close-button"
      name="IconClose"
      style={Platform.OS === 'web' ? match([styles.iconXS, styles.icon]) : undefined}
      accessibilityLabel={formatMessage(messages.rightIconClose)}
      accessibilityHint={formatMessage(messages.homeNavigation)}
      onPress={onPress}
    />
  );
};

const styles = StyleSheet.create({
  icon: {
    marginLeft: theme.spacing['4'],
  },
  iconXS: {
    marginRight: theme.spacing['4'],
  },
});

// ─── Messages ────────────────────────────────────────────────────────────────

const messages = defineMessages({
  rightIconClose: {
    defaultMessage: 'Close',
    description: 'Right Icon | Close',
  },
  homeNavigation: {
    defaultMessage: 'open home page',
    description: 'Home | Navigation',
  },
});
